// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"2737f15e","415":"3421b6b2","453":"391a9e62"}[chunkId] + ".chunk.js";
};